var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoreHorizontal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.975 11.058a1.45 1.45 0 1 1 2.051 2.05 1.45 1.45 0 0 1-2.05-2.05m6 0a1.45 1.45 0 1 1 2.051 2.05 1.45 1.45 0 0 1-2.05-2.05m6 0a1.45 1.45 0 1 1 2.051 2.05 1.45 1.45 0 0 1-2.05-2.05",
  clipRule: "evenodd"
})));
export default SvgMoreHorizontal;